import React, {Component} from 'react';

import Header from "../../components/Header";
import Paragraph from "../../components/Paragraph";
import ContentBlock from "../../components/ContentBlock";
import FooterBlock from "../../components/FooterBlock";

import s from "./Contact.module.scss";
import FirebaseContext from "../../context/firebaseContext";

class ContactPage extends Component {

    componentDidMount() {
    }

    render() {
        return (
            <>
                <ContentBlock
                    background="steelblue"
                >
                    <Header>
                        Оформление заказов /консультация:
                    </Header>
                    <Paragraph>

                        <p>8:00 - 21:00 без выходных</p>

                        <p>info.engstudent@gmail.com</p>
                        <p>englishstudentflashcards</p>
                        <p>english_student2016</p>
                        <p>+38 (073) 227 14 65</p>
                        <p>+38 (066) 638 74 30</p>

                    </Paragraph>
                </ContentBlock>
                <FooterBlock
                    cop="Company 2020"
                />
            </>
        );
    }
}
ContactPage.contextType = FirebaseContext;

export default ContactPage;